var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomClientOfferStage1MainIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 143,
  height: 143,
  viewBox: "0 0 143 143",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 71.5,
  cy: 71.5,
  r: 69.5,
  fill: "white",
  stroke: "url(#paint0_linear_5261_1433)",
  strokeWidth: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M122.931 69.7606C119.194 65.292 114.72 61.2785 109.33 57.5382C102.176 52.5734 94.2033 48.665 86.5121 44.8948C78.8819 41.1598 70.988 37.2918 63.9492 32.4071C58.7037 28.7669 54.3163 24.8347 50.6915 20.5014L49.8104 19.482L26.4294 53.1734L26.9727 53.7866C30.71 58.2552 35.1803 62.2735 40.5699 66.0138C47.7241 70.9786 55.6969 74.887 63.3833 78.6539C71.0134 82.3889 78.9074 86.2569 85.9414 91.1383C91.1869 94.7785 95.5791 98.714 99.2039 103.047L100.09 104.07L123.474 70.3738L122.926 69.7573L122.931 69.7606ZM95.2439 92.7919C77.09 77.8104 53.5176 72.8951 35.4542 57.7832C35.5294 57.6851 35.6127 57.5855 35.6865 57.4792C37.6139 54.7018 37.0917 50.4247 34.8869 47.6995C34.8282 47.6301 34.6508 47.4855 34.6642 47.4662L45.7932 31.4296C46.1298 31.9709 46.7725 32.5743 47.3369 32.9517C48.6441 33.8088 50.2394 33.9426 51.638 33.3746C52.7253 32.9268 53.6667 32.0629 54.3234 30.9728C72.3703 45.9444 95.8333 50.884 113.925 65.801C113.569 66.2837 113.274 66.8309 113.054 67.4363C112.669 68.4934 112.54 69.6134 112.649 70.791C112.758 71.9686 113.096 73.0832 113.638 74.1182C113.971 74.7572 114.371 75.3208 114.804 75.8149C111.04 81.2393 107.272 86.6686 103.508 92.093C103.481 92.06 103.452 92.0188 103.429 91.981C101.176 89.2224 97.4084 89.6422 95.4474 92.4679C95.3736 92.5742 95.3095 92.6871 95.2406 92.7967L95.2439 92.7919Z",
  fill: "url(#paint1_linear_5261_1433)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M103.429 91.9816C103.456 92.0146 103.484 92.0558 103.508 92.0936C107.272 86.6692 111.04 81.2399 114.804 75.8155C114.363 75.3229 113.971 74.7578 113.638 74.1188C113.096 73.0838 112.758 71.9692 112.649 70.7916C112.54 69.614 112.673 68.4892 113.054 67.4369C113.274 66.8315 113.574 66.2876 113.93 65.8049C95.8428 50.8913 72.3813 45.9599 54.3378 30.9835C53.6859 32.0769 52.7507 32.9522 51.6668 33.3952C50.273 33.9666 48.6536 33.8161 47.3416 32.9557C46.7739 32.5831 46.1312 31.9797 45.7979 31.4335L34.6689 47.4701C34.6689 47.4701 34.8378 47.6374 34.8917 47.7034C37.0931 50.4334 37.5947 54.689 35.6672 57.4665C35.5934 57.5727 35.5197 57.679 35.4493 57.7804C53.5127 72.8924 77.09 77.811 95.2439 92.7925C95.3128 92.6829 95.3769 92.57 95.4507 92.4637C97.4117 89.638 101.184 89.2215 103.437 91.9801L103.429 91.9816ZM52.4341 54.1021C50.9996 53.1924 50.6593 51.2602 51.6348 49.8546C52.6103 48.449 54.5212 48.1076 55.9571 49.0254C57.3917 49.9351 57.7975 51.7625 56.8254 53.1633C55.8533 54.5641 53.8686 55.0117 52.4341 54.1021ZM67.0758 72.7794C60.7676 70.1264 60.0503 62.1786 63.8394 56.893C67.9452 51.1615 75.7634 48.1997 82.2441 50.9222C88.5522 53.5752 89.2811 61.5167 85.4953 66.7975C81.3896 72.529 73.5612 75.5053 67.0758 72.7794ZM93.3929 74.6327C91.955 73.7279 91.5425 71.9101 92.5146 70.5094C93.4867 69.1086 95.4747 68.6561 96.9159 69.5561C98.3538 70.4609 98.7007 72.3835 97.7286 73.7842C96.7565 75.185 94.8389 75.5361 93.3962 74.6279L93.3929 74.6327Z",
  fill: "white"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M74.5603 57.9702C74.3256 58.3083 74.3215 58.6633 74.4161 58.958C74.5108 59.2527 74.7461 59.509 75.2436 59.8185L76.7923 57.5869C76.2478 57.345 75.8983 57.3458 75.5095 57.4338C75.1289 57.5203 74.7681 57.6707 74.5569 57.975L74.5603 57.9702Z",
  fill: "url(#paint2_linear_5261_1433)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M74.4387 63.0311L72.7861 65.4125C73.3306 65.6544 73.8114 65.7519 74.1935 65.6735C74.5755 65.5951 74.9357 65.3943 75.1972 65.0175C75.4587 64.6407 75.4944 64.2505 75.3916 63.9572C75.2936 63.6674 74.9381 63.3276 74.4305 63.0326L74.4387 63.0311Z",
  fill: "url(#paint3_linear_5261_1433)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M85.492 66.801C81.3815 72.5292 73.5579 75.5088 67.0759 72.7781C60.7677 70.1251 60.0503 62.1773 63.8395 56.8917C67.9452 51.1602 75.7602 48.2032 82.2408 50.9258C88.5523 53.5739 89.2812 61.5154 85.492 66.801Z",
  fill: "url(#paint4_linear_5261_1433)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M55.9572 49.0249C54.5227 48.1153 52.6069 48.4533 51.6348 49.8541C50.6627 51.2549 50.9981 53.1838 52.4341 54.1016C53.8686 55.0112 55.8533 54.5636 56.8254 53.1628C57.7975 51.762 57.3917 49.9346 55.9572 49.0249Z",
  fill: "url(#paint5_linear_5261_1433)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M96.916 69.5564C95.4781 68.6516 93.4901 69.104 92.5147 70.5097C91.5392 71.9153 91.9517 73.7331 93.3929 74.633C94.8308 75.5379 96.7532 75.1902 97.7253 73.7894C98.6975 72.3886 98.3587 70.4645 96.9127 69.5612L96.916 69.5564Z",
  fill: "url(#paint6_linear_5261_1433)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M65.1624 60.523L68.6821 55.4512L70.8601 56.9626C71.1774 57.1829 71.4084 57.4505 71.5531 57.7656C71.7025 58.084 71.7622 58.4188 71.7321 58.7701C71.7069 59.1247 71.5853 59.459 71.3674 59.773C71.1395 60.1014 70.8605 60.3444 70.5304 60.5018C70.2085 60.6577 69.8706 60.7237 69.5167 60.7C69.1675 60.6796 68.8343 60.5592 68.517 60.339L67.565 59.6784L66.3884 61.3738L65.1624 60.523ZM68.2926 58.5838L69.0931 59.1393C69.1989 59.2127 69.3135 59.2529 69.4369 59.2598C69.5603 59.2668 69.6803 59.2427 69.7969 59.1876C69.9135 59.1325 70.0136 59.0446 70.0974 58.9239C70.1846 58.7983 70.2319 58.6737 70.2394 58.55C70.2468 58.4264 70.224 58.3104 70.171 58.202C70.118 58.0936 70.0386 58.0027 69.9328 57.9293L69.1323 57.3738L68.2926 58.5838Z",
  fill: "white"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M69.7932 63.7367L73.3129 58.6648L74.539 59.5157L71.7735 63.5007L74.0236 65.0622L73.2694 66.149L69.7932 63.7367Z",
  fill: "white"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M74.0437 66.6864L77.5635 61.6146L78.6597 62.3753L78.7923 67.8348L78.5795 67.6335C78.6661 67.4574 78.7524 67.2919 78.8386 67.137C78.9247 66.982 79.0092 66.8295 79.092 66.6794C79.1796 66.5327 79.2688 66.3835 79.3598 66.2319C79.4555 66.0837 79.5597 65.9234 79.6722 65.751C79.7895 65.5819 79.9169 65.3984 80.0543 65.2003L80.9242 63.9469L82.1142 64.7727L78.5944 69.8445L77.4838 69.0737L77.3162 63.4182L77.6488 63.7242C77.5119 63.9727 77.3937 64.1841 77.2942 64.3583C77.2028 64.5311 77.1183 64.6836 77.0408 64.8159C76.9681 64.9515 76.8989 65.0716 76.8333 65.1764C76.7677 65.2812 76.6997 65.3843 76.6293 65.4857C76.5671 65.5857 76.4941 65.696 76.4103 65.8168L75.2337 67.5122L74.0437 66.6864Z",
  fill: "white"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5596 109.097C68.803 101.853 68.803 90.1095 61.5596 82.8661C54.3162 75.6228 42.5724 75.6228 35.329 82.8661C28.0856 90.1095 28.0856 101.853 35.329 109.097C42.5724 116.34 54.3162 116.34 61.5596 109.097Z",
  fill: "#F28A2A"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8665 79.4036C41.0219 70.2482 55.866 70.2484 65.0215 79.4036C74.1771 88.5591 74.1771 103.403 65.0215 112.559C55.866 121.714 41.022 121.714 31.8665 112.559C22.7113 103.403 22.7111 88.559 31.8665 79.4036ZM61.5597 82.8662C54.3163 75.6228 42.5725 75.6228 35.3291 82.8662L34.995 83.2091C28.0876 90.4756 28.1989 101.967 35.3291 109.097C42.4593 116.227 53.9503 116.338 61.2167 109.431L61.5597 109.097C68.6898 101.967 68.801 90.4756 61.8937 83.2091L61.5597 82.8662Z",
  fill: "white"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9079 93.0322C44.9079 93.0322 44.9079 93.0434 44.9079 93.0472C44.9042 93.654 44.2059 93.99 43.7093 93.639C43.1715 93.2581 42.49 93.0304 41.7507 93.0304C41.0113 93.0304 40.3298 93.2581 39.7921 93.639C39.2973 93.99 38.5971 93.6521 38.5934 93.0472C38.5934 93.0416 38.5934 93.036 38.5934 93.0322C38.5934 91.4751 40.0068 90.2129 41.7507 90.2129C43.4945 90.2129 44.9079 91.4751 44.9079 93.0322Z",
  fill: "#5F1341"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M51.9825 93.0322C51.9825 93.0322 51.9825 93.0434 51.9825 93.0472C51.9863 93.654 52.6846 93.99 53.1812 93.639C53.719 93.2581 54.4004 93.0304 55.1398 93.0304C55.8792 93.0304 56.5607 93.2581 57.0984 93.639C57.5932 93.99 58.2934 93.6521 58.2971 93.0472C58.2971 93.0416 58.2971 93.036 58.2971 93.0322C58.2971 91.4751 56.8837 90.2129 55.1398 90.2129C53.3959 90.2129 51.9825 91.4751 51.9825 93.0322Z",
  fill: "#5F1341"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M48.4444 107.495C44.1818 107.495 40.3729 105.092 38.7447 101.374C38.474 100.756 38.756 100.036 39.374 99.765C39.992 99.4943 40.7127 99.7762 40.9834 100.394C42.2232 103.225 45.1527 105.053 48.4462 105.053C51.7398 105.053 54.6693 103.225 55.909 100.394C56.1798 99.7762 56.9005 99.4943 57.5185 99.765C58.1365 100.036 58.4184 100.756 58.1477 101.374C56.5177 105.094 52.7107 107.495 48.4481 107.495H48.4444Z",
  fill: "#5F1341"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5261_1433",
  x1: 4,
  y1: 71.4926,
  x2: 139.002,
  y2: 71.4926,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_5261_1433",
  x1: 38.1733,
  y1: 36.2507,
  x2: 111.731,
  y2: 87.2977,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_5261_1433",
  x1: 74.6893,
  y1: 57.7842,
  x2: 76.0163,
  y2: 58.7051,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_5261_1433",
  x1: 73.6098,
  y1: 64.2152,
  x2: 75.057,
  y2: 65.2195,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_5261_1433",
  x1: 65.0331,
  y1: 55.1693,
  x2: 84.2914,
  y2: 68.5341,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_5261_1433",
  x1: 51.6671,
  y1: 49.8077,
  x2: 56.7202,
  y2: 53.3145,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_5261_1433",
  x1: 92.6294,
  y1: 70.3443,
  x2: 97.6826,
  y2: 73.8511,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB8B24"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5F0F40"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomClientOfferStage1MainIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/custom-client-offer-stage-1-main-icon.1b72b167692aef7471c63730d378fc4a.svg";